import { render, staticRenderFns } from "./join-affiliate-program.vue?vue&type=template&id=5e4484e0&"
import script from "./join-affiliate-program.vue?vue&type=script&lang=js&"
export * from "./join-affiliate-program.vue?vue&type=script&lang=js&"
import style0 from "./join-affiliate-program.vue?vue&type=style&index=0&id=5e4484e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports